@media (min-width: 768px){#sidebar{position:fixed;display:flex;overflow:visible}}
/*# sourceMappingURL=home.component-O34A4T2G.css.map */
